import React, { useImperativeHandle, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Button from '../../UI/button/button';
import styles from './modal-insurance-success.module.scss';

const ModalInsuranceSuccess = React.forwardRef(({ visible, onClickButton, textButton, ...rest }, ref) => {
  const [modalVisible, setModalVisible] = useState(visible);

  useImperativeHandle(ref, () => ({
    closeModal,
    openModal,
    visible: modalVisible,
  }));

  const closeModal = () => setModalVisible(false);
  const openModal = () => setModalVisible(true);

  return (
    <div className={`${styles.modalWrapper} ${modalVisible && styles.visible}`} {...rest}>
      <div id="successInsuranceButtonClose" className={styles.closeIcon} onClick={closeModal}>
        <FontAwesomeIcon icon={faTimesCircle} />
      </div>
      <div className={styles.modalContent}>
        <div className={styles.contentTop}>
          <img className={styles.contentTopImage} src="/image/insurance-protected.png" alt="" />
          <h5 className={styles.contentTopText}>SUPERSEGURO ATIVADO COM SUCESSO!</h5>
        </div>
        <div className={styles.contentBottom}>
          <h5 className={styles.contentBottomText}>
            {/* When we create the lending page */}
            {/* <strong>Seu empréstimo agora está protegido.</strong>Para saber mais
            sobre os benefícios, clique no botão abaixo: */}
            Seu empréstimo está protegido! Acabamos de enviar um e-mail para você com o contrato e detalhes do
            benefício. 🤝😁
          </h5>
          <Button id="successInsuranceButtonOk" onClick={onClickButton || closeModal} rounded>
            {textButton || 'OK'}
          </Button>
        </div>
      </div>
    </div>
  );
});

ModalInsuranceSuccess.displayName = 'ModalInsuranceSuccess';

export default React.memo(ModalInsuranceSuccess);
